import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';

export type AlertType = 'default' | 'info' | 'warning' | 'danger' | 'success';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  imports: [IonButton, IonIcon],
})
export class AlertComponent {
  @Input() margin?: string = '15px 0';
  @Input() title?: string;
  @Input() description?: string;
  @Input() type: AlertType = 'default';
  @Input() showIcon: boolean = true;
  @Input() size: 'small' | 'regular' = 'regular';
  /** When set, renders a button under the description that emits actionClick. */
  @Input() actionLabel?: string;
  @Output() actionClick = new EventEmitter<void>();

  get icon(): string {
    const icons: Record<AlertType, string> = {
      default: 'info-circle',
      info: 'info-circle',
      warning: 'info-circle',
      danger: 'info-circle',
      success: 'check-circle',
    };
    return icons[this.type];
  }

  get alertClass(): string {
    return `alert-${this.type}`;
  }
}
